import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import EmailIcon from "@mui/icons-material/Email";
import { BROADCAST_TYPES, BroadcastTypeConfig } from "../broadcastTypes";
import { ReactNode } from "react";

const iconMap: Record<string, ReactNode> = {
  Event: <EventIcon sx={{ fontSize: 40, color: "#9d2362" }} />,
  Email: <EmailIcon sx={{ fontSize: 40, color: "#9d2362" }} />,
};

interface TypeSelectorProps {
  selectedType: string;
  onSelect: (typeId: string) => void;
}

const TypeSelector = ({ selectedType, onSelect }: TypeSelectorProps) => {
  return (
    <Grid container spacing={3} sx={{ mt: 1 }}>
      {BROADCAST_TYPES.map((type: BroadcastTypeConfig) => (
        <Grid item xs={12} sm={6} key={type.id}>
          <Card
            variant="outlined"
            sx={{
              border: selectedType === type.id ? "2px solid #9d2362" : "1px solid #e0e0e0",
              borderRadius: 2,
              transition: "border 0.2s",
              "&:hover": { borderColor: "#9d2362" },
            }}
          >
            <CardActionArea onClick={() => onSelect(type.id)} sx={{ p: 2 }}>
              <CardContent sx={{ textAlign: "center" }}>
                {iconMap[type.iconName]}
                <Typography variant="h6" sx={{ mt: 1, fontWeight: 600 }}>
                  {type.label}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  {type.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default TypeSelector;
